<template>
    <p-modal
        :name="name"
        label="Select To Calculate"
        size="md"
        no-close-on-esc
        @show="loadCalculation">
        <template v-slot:modal-footer>
            <b-row>
                <b-col>
                    <p-button variant="outline-primary" @click="modalCancel">
                        Cancel
                    </p-button>
                    <p-button variant="primary" @click="modalApply" class="ms-2">
                        Apply
                    </p-button>
                </b-col>
            </b-row>
        </template>
        <template v-slot:default>
            <p-form ref="calcForm">
                <b-row>
                    <b-col>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>
                                        <b-row class="ps-3">
                                            <b-col>
                                            <b-form-radio :value="0" v-model="calculationOption" :disabled="disableCost">
                                                Cost
                                            </b-form-radio>
                                            </b-col>
                                        </b-row>
                                    </th>
                                    <th>
                                        <b-row class="ps-3">
                                            <b-col>
                                            <b-form-radio :value="1" v-model="calculationOption">
                                                Margin
                                            </b-form-radio>
                                            </b-col>
                                        </b-row>
                                    </th>
                                    <th>
                                        <b-row class="ps-3">
                                            <b-col>
                                            <b-form-radio :value="2" v-model="calculationOption">
                                                Selling Price
                                            </b-form-radio>
                                            </b-col>
                                        </b-row>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <p-number input-type="money" rules="required" name="Cost" label=""
                                            v-model.number="tempPricing.cost" @change="updateCalculation()"
                                            :disabled="calculationOption == '0' || disableCost" />
                                    </td>
                                    <td>
                                        <p-number input-type="percent" :rules="marginValidationRules" name="Margin" label=""
                                            v-model.number="tempPricing.margin" @change="updateCalculation()"
                                            :disabled="calculationOption == '1'" />
                                    </td>
                                    <td>
                                        <p-number input-type="money" rules="required" name="Retail" label=""
                                            v-model.number="tempPricing.retail" @change="updateCalculation()"
                                            :disabled="calculationOption == '2'" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>  
                <b-row class="text-bold text-center">
                    <b-col>
                        <span>
                            <div>*This utility does not impact database values until they are applied and the product or book is saved.</div>
                            <br />
                            <div v-if="parameters.updateUsedPricesFromNew">*Note that Mosaic is configured with the Book Pricing Setting to 'Update Used Prices from New'. Changing the retail price will also update the used price based on the <a href="/storesetup" target="_blank">current configuration</a>.</div>
                        </span>
                    </b-col>
                </b-row>
            </p-form>
        </template>
    </p-modal>
</template>

<script>
import pricing from '@/services/PricingCalculations.js';

export default {
    props: {
        initialValues: {
            type: Object,
            default: () => {
                return {
                    margin: 0,
                    cost: 0,
                    retail: 0
                };
            }
        },
        name: {
            type: String,
            default: 'priceCalculator'
        },
        parameters: Object,
        disableCost: { type: Boolean, default: false }
    },
    data() {
        return {
            calculationOption: 2,
            tempPricing: {
                margin: 0,
                cost: 0,
                retail: 0,
                sku: 0
            }
        };
    },
    computed: {
        marginValidationRules() {
            //can only have margin == 100 if cost is zero.
            //otherwise the percentage of revenue that is profit can never reach 100%.
            return this.tempPricing.cost == 0
                ? 'required|oneOf:0,100'
                : 'required|max_value:99.99';
        }
    },
    methods: {        
        loadCalculation() {
            this.tempPricing.cost = this.initialValues.cost;
            this.tempPricing.retail = this.initialValues.sellingPrice || this.initialValues.retail;
            this.tempPricing.sku = this.initialValues.sku;
            this.tempPricing.margin = this.initialValues.margin;
            
            this.$nextTick(() => this.$refs.calcForm?.reset());
        },
        modalApply() {
            this.$bvModal
                .msgBoxConfirm('Are you sure you wish to apply these pricing changes?', {
                    title: 'Confirm Pricing Changes',
                    okTitle: 'Proceed',
                    cancelTitle: 'Cancel',
                    okVariant: 'primary',
                    cancelVariant: 'secondary'
                })
                .then(value => {
                    if (value) {
                        this.$emit('apply', this.tempPricing);
                        this.$bvModal.hide(this.name);
                    }
                });
        },
        modalCancel() {
            this.$bvModal.hide(this.name);
        },
        updateCalculation: function() {
            switch (this.calculationOption) {
                case 0:
                    this.tempPricing.cost = pricing.computeCost(
                        this.tempPricing.retail,
                        this.tempPricing.margin
                    );
                    break;
                case 1:
                    this.tempPricing.margin = pricing.computeMargin(
                        this.tempPricing.cost,
                        this.tempPricing.retail
                    );
                    break;
                case 2:
                    if (
                        !pricing.isInvalidMargin(
                            this.tempPricing.margin,
                            this.tempPricing.cost
                        )
                    ) {
                        this.tempPricing.retail = pricing.computeRetail(
                            this.tempPricing.cost,
                            this.tempPricing.margin,
                            this.tempPricing.retail,
                            this.parameters.roundingTarget
                        );
                    }
                    this.tempPricing.margin = pricing.computeMargin(
                        this.tempPricing.cost,
                        this.tempPricing.retail
                    );
                    break;
            }
        }
    }
};
</script>
